"use client";
import { RefreshCw } from "lucide-react";
import { StripeCardForm } from "./StripeCardForm";
import { CardSavedView } from "./CardSavedView";
import type { CaptureState } from "../hooks/useCapturePhase";
import { Button } from "@/components/ui/Button";
import { usePatientDetailsContext } from "@/features/patient/context/PatientDetailsContext";
import { Alert } from "@/components/ui/Alert";

interface CardCapturePanelProps {
  onSuccess: VoidFunction;
  onRetry: VoidFunction;
  captureState: CaptureState;
}

export function CardCapturePanel({
  onSuccess,
  onRetry,
  captureState,
}: CardCapturePanelProps) {
  const { patient } = usePatientDetailsContext();
  const patientId = patient?.patientId ?? "";

  if (captureState.phase === "ready") {
    return (
      <StripeCardForm
        patientId={patientId}
        stripePromise={captureState.stripePromise}
        clientSecret={captureState.clientSecret}
        onSuccess={onSuccess}
      />
    );
  }

  if (captureState.phase === "error") {
    return (
      <div className="flex flex-col gap-5">
        <Alert variant="error" message={captureState.message} />
        <Button onClick={onRetry}>
          <RefreshCw className="size-3.5" />
          Try Again
        </Button>
      </div>
    );
  }

  if (captureState.phase === "success") {
    return <CardSavedView />;
  }

  return null;
}
